import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChild,
    ViewChildren
} from '@angular/core';
import { PhotoService } from '../../../photo/services/photo.service';
import { CategoryService } from '../../../category/services/category.service';
import { Photo } from '../../../../shared/models/cameralla-photo.model';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CategoryModel } from '../../../../shared/models/cameralla-category.model';
import { debounceTime, filter } from 'rxjs/operators';
import { fromEvent, Subscription } from 'rxjs';
import * as $ from 'jquery';
import { PhotoOrder } from '../../../../shared/models/cameralla-photo-order.model';
import { Location } from '@angular/common';
import { PhotoCardComponent } from '../../../../shared/components/photo-card/photo-card.component';
import { GlobalVariables } from '../../../../shared/models/cameralla-global.model';
import { UserService } from '../../../user/services/user.service';
import { CamerallaUser } from '../../../../shared/models/cameralla-user.model';
import { CamerallaAuthService } from '../../../../shared/services/authentication-services/cameralla-auth.service';
import { HttpClient } from '@angular/common/http';
import * as  _ from 'underscore';
import { NgxMasonryOptions } from 'ngx-masonry';
import { FilterDefaultModel } from '../../../../shared/models/cameralla-filter-default.model';
import { FilterPhotoForm } from '../../../administrator/filter-photo-form/filter-photo-form';
import AppShareHelper from '../../../../shared/utils/helper';
import { PopupMarkerComponent } from "../../../../shared/components/popup-marker/popup-marker.component";
import { ConfigService } from "../../../../shared/services/config.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormControl } from "@angular/forms";
import * as moment from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from "@angular/material-moment-adapter";
import { AdvertisingService } from "../../../../shared/services/advertising.service";
import { GroupService } from "../../../user/services/group.service";
import { PartnerService } from "../../../../shared/services/partner.service";
import { PermissionAdminService } from "../../../../shared/services/guard-services/permission-admin.service";
import { LanguageConstant } from "../../../../shared/constants/language-constant";

declare var jQuery: any;

export const MY_MONTH_FORMATS = {
    parse: {
        dateInput: 'LL',
    },
    display: {
        dateInput: 'MMMM YYYY', // this is the format showing on the input element
        monthYearLabel: 'MMMM YYYY', // this is showing on the calendar
    },
};

@Component({
    templateUrl: './home.component.html',
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        
        {provide: MAT_DATE_FORMATS, useValue: MY_MONTH_FORMATS},
    ],
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
    static readonly maxWidthMobile = 991;
    @ViewChild('datepickerFilter') datePickerElement;
    @ViewChild('datepickerLocationFilter') datepickerLocationFilter;
    @ViewChildren('photoCard') photoCardComponents: QueryList<PhotoCardComponent>;
    
    goldenPhotoFormControl = new FormControl(null);
    goldenLocationFormControl = new FormControl(null);
    static EDITOR_CHOICE_FILTER_ID = 'editorChoice';
    
    vipTabActive = false;
    followingPhotosActive = false;
    limit = 10;
    skip = 0;
    popupType = 'popup';
    photos: Photo[] | any = [];
    previousPhotos: Photo[] = [];
    newPhotos = 0;
    photoOrder: PhotoOrder;
    filters: CategoryModel[] = [];
    currentAds: any = false;
    advertisementPhoto = [];
    pinnedPostArr = [];
    pinnedPost: any = null;
    randomOrderAdvertising = null;
    filterMonth;
    searchTerm = '';
    testingMode = false;
    goldenPhotoFilter = false;
    goldenLocationFilter = false;
    editorChoiceFormControl = new FormControl(null);
    public activeQuickFilter: any = {};
    selectedFilters = [];
    arrayFilterOption: FilterDefaultModel[] = [];
    lazyLoadTriggered = true;
    _srolling: Subscription;
    loaded = false;
    userId: number;
    isAdmin = false;
    partnerRoute: string;
    userProfile: CamerallaUser;
    homeRoute = GlobalVariables.HOME_ROUTE;
    membershipTags;
    userPreferredLanguage = LanguageConstant.NO;
    partnerObjects = GlobalVariables.partnerObjects;
    partnerNavigators = GlobalVariables.partnerNavigators;
    partnerInfo: any = {
        BannerUrl: '',
        BannerMobileUrl: '',
        LogoUrl: '',
        Title: '',
        Welcome: '',
        Slogan: '',
        Content: '',
        BannerArr: [],
        BannerMobileArr: [],
    };
    defaultFilter: any = {
        tags: [],
        searchText: '',
        categories: []
    };
    selectFeed: number;
    active = true;
    today = new Date();
    vipMember = false;
    groupId = null;
    
    public renderImageOptions: NgxMasonryOptions = {
        transitionDuration: '1s',
        itemSelector: '.grid-item',
        horizontalOrder: false
    };
    editorChoiceFilter = false;
    
    routeSubscription: Subscription;
    
    @ViewChild('photoZone') photoZone;
    
    constructor(private photoService: PhotoService,
                private categoryService: CategoryService,
                private configService: ConfigService,
                private router: Router,
                private route: ActivatedRoute,
                protected _modalService: NgbModal,
                private location: Location,
                private userService: UserService,
                public advertisingService: AdvertisingService,
                private authService: CamerallaAuthService,
                private http: HttpClient,
                private groupService: GroupService,
                private cdr: ChangeDetectorRef
    ) {
        this.photoOrder = new PhotoOrder();
        this.userId = +this.authService.getLocalUserInfo()['id'];
        this.selectFeed = null;
    }
    
    private getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }
    
    outsideMemberTagPromise = AppShareHelper.defer();
    ngOnInit() {
        localStorage.removeItem('navigateFromDetailPage');
        this.advertisingService.getAdvertising(null, true, null, true).toPromise().then((resAds: any) => {
            if (resAds.Data.length) {
                resAds.Data.forEach(ads => {
                    if (ads.subType == 'pinned') {
                        this.pinnedPostArr.push(ads);
                    } else {
                        this.advertisementPhoto.push({
                            original: ads.bannerUrl,
                            thumbnail: ads.bannerThumbUrl,
                            language: ads.language,
                            tags: ads.tags,
                            navigateUrl: ads.navigateUrl,
                            partnerId: ads.partnerId,
                            id: ads.id + new Date().getTime(),
                            rawId: ads.id,
                            type: 'advertisings',
                            height: 300,
                            width: 300
                        });
                    }
                })
            }
            
            this.userService.getUserInformation(this.userId).then(
                (resolve: any[]) => {
                    this.vipMember = AppShareHelper.checkVipMember(resolve[0].accessLevel);
                    this.membershipTags = (resolve[0].memberships);
                    this.loaded = true;
                    this.outsideMemberTagPromise.resolve(true);
                    this.userPreferredLanguage = resolve[0].preferredLanguage ? resolve[0].preferredLanguage :this.userPreferredLanguage;
                    this.isAdmin = (resolve[0].role == PermissionAdminService.adminConst);
                    this.route.params.subscribe(
                        params => {
                            this.vipTabActive = this.route.snapshot['_routerState'].url === GlobalVariables.MEMBER_ONLY;
                            this.followingPhotosActive = this.route.snapshot['_routerState'].url === GlobalVariables.MY_FOLLOWING;
                            
                            let urlFilterApi = FilterPhotoForm.filterAPI;
                            this.groupId = null;
                            this.partnerRoute = params['partner'] || (this.vipTabActive ? 'vip' : (this.followingPhotosActive ? 'following' :this.homeRoute));
                            
                            this.http.get(urlFilterApi)
                                .subscribe(
                                    (res: any) => {
                                        if (res.Data) {
                                            this.arrayFilterOption = [];
                                            if (res.Data && res.Data.defaultFilters && res.Data.defaultFilters.length) {
                                                res.Data.defaultFilters.forEach((filterModel) => {
                                                    this.arrayFilterOption.push({
                                                        display: filterModel.text,
                                                        value: filterModel,
                                                        readonly: true,
                                                        class: '',
                                                        partner: filterModel.partner,
                                                        isDropdown: filterModel.isDropdown,
                                                        dropDownList: filterModel.dropDownList,
                                                        tags: filterModel.tags
                                                    });
                                                });
                                            }
                                        }
                                    });
                            
                            if (!this.active) {
                                return;
                            }
                            
                            if (this.groupId) {
                                GlobalVariables.CURRENT_PARTNER = {
                                    value: 'group',
                                    id: this.groupId,
                                };
                                this.getPartnerDetail(PartnerService.partnerAPI + 'group/' + this.groupId);
                            } else {
                                // Get partnerInfo
                                this.partnerNavigators.forEach((partner: any) => {
                                    const me = this;
                                    if (partner.value === me.partnerRoute) {
                                        GlobalVariables.CURRENT_PARTNER = partner;
                                        me.photoOrder.selectedPartner = partner;
                                        this.getPartnerDetail(PartnerService.partnerAPI + partner.id);
                                    }
                                });
                            }
    
                            this.getCategories().then(
                                resolve => {
                                    this.filters = resolve;
            
                                    this.photoService.subscribe(PhotoService.SET_PHOTOS_FILTER, () => {
                                        if (!this.active) {
                                            return;
                                        }
                
                                        this.skip = 0;
                                        // Set order descending is default
                                        this.photoOrder.selectedOrder = {name: 'Descending', value: 'DESC'};
                                        this.getPhotos(this.selectedFilters, this.photoOrder, this.limit, this.skip, {}, this.searchTerm).then(
                                            resolve => {
                                                this.photos = [];
                                                if (this.pinnedPost) {
                                                    this.photos.push(this.pinnedPost);
                                                }
                        
                                                this.photos.push(...resolve);
                                                
                                                if (resolve && resolve.length == 10) {
                                                    const adsPhoto = this.getAdvertisingPhotos(this.skip);
                                                    if (adsPhoto) {
                                                        this.photos.push(adsPhoto);
                                                    }
                                                }
                        
                                                this.updateMansoryLayout();
                                                this.newPhotos = this.photos.length - AppShareHelper.checkLoadedPhotos(this.previousPhotos, this.photos);
                                            },
                                            reject => console.log(reject)
                                        );
                                    });
            
                                    this.photoService.subscribe(PhotoService.LAZY_LOADING_PHOTOS, (skip) => {
                                        if (!this.active) {
                                            return;
                                        }
                                        
                                        this.getPhotos(this.selectedFilters, this.photoOrder, this.limit, skip, {}, this.searchTerm).then(
                                            resolve => {
                                                let dif = this.photos.length;
                                                this.photos.push(...resolve);
                        
                                                if (resolve && resolve.length == 10) {
                                                    const adsPhoto = this.getAdvertisingPhotos(this.skip);
                                                    if (adsPhoto) {
                                                        this.photos.push(adsPhoto);
                                                    }
                                                }
                        
                                                dif++;
                                                this.updateMansoryLayout();
                        
                                                this.newPhotos += this.photos.length - dif;
                                            },
                                            reject => {
                                                console.log(reject);
                                            }
                                        );
                                    });
            
                                    setTimeout(function () {
                                        $('.dropdown-menu').click(function (e) {
                                            e.stopPropagation();
                                        });
                                    }, 0);
            
            
                                    this.route.queryParams.subscribe(
                                        params => {
                                            if (params['category']) {
                                                const category: any = this.filters.find((el: CategoryModel) => el.name === params['category']);
                                                if (params['subCategory']) {
                                                    const subCategory = category.subCategories.find((el: CategoryModel) => el.name === params['subCategory']);
                                                    this.selectFilter(category, subCategory);
                                                } else {
                                                    this.selectFilter(category);
                                                }
                                            } else {
                                                this.resetFilters();
                                                if (localStorage.getItem('navigateFromDetailPage')) {
                                                    if (localStorage.getItem(this.photoService.convertPartnerString('activeFilter'))) {
                                                        //this.activeFilter(JSON.parse(localStorage.getItem(this.photoService.convertPartnerString('activeFilter'))), null);
                                                    } else {
                                                        this.outsideMemberTagPromise.promise.then(() => {
                                                            this.renderPhoto(this.selectedFilters, {}, null, this.searchTerm);
                                                        })
                                                    }
                                                } else {
                                                    this.outsideMemberTagPromise.promise.then(() => {
                                                        this.renderPhoto(this.selectedFilters, {}, null, this.searchTerm);
                                                    })
                                                }
                        
                                            }
                                        }
                                    );
                                },
                                reject => console.log(reject)
                            );
                        }
                    );
                    
                    this.configService.getConfig(this.popupType).subscribe((popupRes: any) => {
                        if (popupRes.Data && popupRes.Data.length) {
                            const videos = popupRes.Data[0].data.Config;
                            
                            if (typeof videos === 'object' && videos !== null) {
                                if (popupRes.Data[0].data.IsEnable && !AppShareHelper.getWithExpiry(popupRes.Data[0].data.KeyName + '-' + this.userId) && resolve[0].accessLevel && !resolve[0].memberships.includes('english')) {
                                    const modalRef = this._modalService.open(PopupMarkerComponent, {
                                        centered: true,
                                        size: "lg"
                                    });
                                    
                                    
                                    if (videos[resolve[0].accessLevel.toLowerCase()]) {
                                        modalRef.componentInstance.videoId = videos[resolve[0].accessLevel.toLowerCase()];
                                    } else {
                                        modalRef.componentInstance.videoId = videos['others']
                                    }
                                    
                                    if (popupRes.Data[0].data.LoopPeriod || popupRes.Data[0].data.LoopPeriod != 0) {
                                        AppShareHelper.setWithExpiry(popupRes.Data[0].data.KeyName + '-' + this.userId, true, popupRes.Data[0].data.LoopPeriod);
                                    }
                                }
                            }
                        }
                        //this.loaded = true;
                    })
                    
                    this.userProfile = Object.assign(resolve[0], resolve[1]);
                }
            );
            
        })
        
        
        if (localStorage.getItem('navigateFromDetailPage')) {
            this.renderImageOptions.transitionDuration = '0s';
        }
        
        // this.getUserGroups()
        
        this.testingMode = this.route.snapshot.queryParams.testingMode;
        
        PhotoCardComponent.photosLoaded = 0;
        
        
        
        this.routeSubscription = this.router.events.pipe(
            filter(routeEvent => routeEvent instanceof NavigationEnd),
        ).subscribe((routeEvent: any) => {
            // Only action if this home belongs to the right partner that has been routed to.
            let rightPartnerComponent = false;
            if (this.partnerRoute === 'vip' && routeEvent.url === GlobalVariables.MEMBER_ONLY) {
                this.vipTabActive = true;
                rightPartnerComponent = true;
            } else if (this.partnerRoute === 'following' && routeEvent.url === GlobalVariables.MY_FOLLOWING) {
                this.followingPhotosActive = true
            } else {
                this.vipTabActive = false
            }
            
            // @ts-ignore
            if (this.partnerRoute === '' && routeEvent.url === '/') {
                rightPartnerComponent = true;
            }
            
            
            // @ts-ignore
            if (this.partnerRoute !== '' && routeEvent.url.indexOf(this.partnerRoute.toLowerCase()) > -1) {
                rightPartnerComponent = true;
            }
            
            
            // @ts-ignore
            if (rightPartnerComponent) {
                this.active = true;
                
                // Apply partners to global variable
                this.partnerNavigators.forEach((partner: any) => {
                    if (partner.value === this.partnerRoute) {
                        GlobalVariables.CURRENT_PARTNER = partner;
                    }
                });
                const scrollPosition = localStorage.getItem(this.photoService.convertPartnerString('scrollPosition'));
                
                setTimeout(() => {
                    this.updateMansoryLayout();
                });
                
                if (this.photoService.modifiedPhoto) { // update photo view- edit form photo detail
                    const photoCardComponent: PhotoCardComponent = this.photoCardComponents.find(factory => factory.photo.id === this.photoService.modifiedPhoto.id);
                    if (photoCardComponent) {
                        photoCardComponent.updatePhotoView(this.photoService.modifiedPhoto);
                        this.cdr.detectChanges();
                    }
                    this.photoService.modifiedPhoto = null;
                }
                
                if (scrollPosition) {
                    setTimeout(() => {
                        $(window).scrollTop(scrollPosition);
                        setTimeout(() => {
                            this.lazyLoadTriggered = true;
                        }, 150);
                    }, 600);
                }
            } else {
                this.lazyLoadTriggered = false;
                this.active = false;
            }
        });
        
    }
    
    private getPartnerDetail(url) {
        this.http.get(url)
            .subscribe(
                (res: any) => {
                    if (res.Data) {
                        // Change http to https of the banner image.
                        this.partnerInfo.BannerUrl = ((res.Data.banner && res.Data.banner.includes('http:') && !res.Data.banner.includes('https:'))) ?
                            res.Data.banner.replace('http', 'https') : res.Data.banner;
                        this.partnerInfo.BannerMobileUrl = ((res.Data.bannerMobile && res.Data.bannerMobile.includes('http:') && !res.Data.banner.includes('https:'))) ?
                            res.Data.bannerMobile.replace('http', 'https') : res.Data.bannerMobile;
                        this.partnerInfo.LogoUrl = res.Data.logo;
                        this.partnerInfo.Title = res.Data.title;
                        this.partnerInfo.Slogan = res.Data.slogan;
                        this.partnerInfo.Welcome = res.Data.welcome;
                        this.partnerInfo.BannerNavigateUrl = res.Data.bannerNavigateUrl;
                        this.partnerInfo.Content = res.Data.content;
                        
                        const bannerArr = Array.isArray(res.Data.bannerArr) ? res.Data.bannerArr : [];
                        bannerArr.forEach(banner => {
                            if (!banner.tags || this.canShowAds(banner.tags)) {
                                this.partnerInfo.BannerArr.push(banner);
                            }
                        })
                        
                        const mobileBannerArr = Array.isArray(res.Data.bannerMobileArr) ? res.Data.bannerMobileArr : [];
                        mobileBannerArr.forEach(banner => {
                            if (!banner.tags || this.canShowAds(banner.tags)) {
                                this.partnerInfo.BannerMobileArr.push(banner);
                            }
                        })
                    }
                },
                (error) => {
                }
            );
    }
    
    public activeFilter(filter, position) {
        this.searchTerm = '';
        this.selectedFilters = [];
        this.skip = 0;
        
        if (position != null) {
            filter.value.childPostion = position;
        }
        localStorage.setItem(this.photoService.convertPartnerString('activeFilter'), JSON.stringify(filter));
        localStorage.removeItem(this.photoService.convertPartnerString('selectedFilter'));
        
        if (this.activeQuickFilter.value && filter.value.id == this.activeQuickFilter.value.id
            && !filter.value.active) {
            // filter.value.active - just for case golden photo filter
            if (filter.isDropdown) {
                $(`#child-item-filter-${filter.value.id} > button.active`).removeClass('active');
                if (!this.arraysMatch(this.activeQuickFilter.tags, filter.dropDownList[position])) {
                    $(`#child-item-filter-${filter.value.id}`).children().eq(position).addClass('active');
                    this.activeQuickFilter.tags = filter.dropDownList[position];
                } else {
                    this.arrayFilterOption.forEach((item: any) => {
                        item.class = '';
                    });
                    this.activeQuickFilter = {};
                    localStorage.removeItem(this.photoService.convertPartnerString('activeFilter'));
                }
            } else {
                this.activeQuickFilter = {};
                this.arrayFilterOption.forEach((item: any) => {
                    item.class = '';
                });
                localStorage.removeItem(this.photoService.convertPartnerString('activeFilter'));
            }
            
        } else {
            if (!this.customQuickFilterArr.includes(filter.value.id)) {
                this.clearCustomQuickFilter();
                this.photoOrder.selectedBrowse = filter.value.sort_by.selectedBrowse;
                this.photoOrder.selectedOrder = filter.value.sort_by.selectedOrder;
                this.photoOrder.selectedTimeFrame = filter.value.sort_by.selectedTimeFrame;
            }
            
            this.arrayFilterOption.forEach((item: any) => {
                if (item.value.id == filter.value.id) {
                    item.class = 'active';
                    if (typeof (filter.value.childPostion) != 'undefined' && filter.value.childPostion != null) {
                        setTimeout(() => {
                            $(`#child-item-filter-${filter.value.id}`).children().eq(filter.value.childPostion).addClass('active');
                        }, 100);
                    }
                } else {
                    item.class = '';
                    if (item.isDropdown) {
                        $(`#child-item-filter-${item.value.id} > button.active`).removeClass('active');
                    }
                }
            });
            this.activeQuickFilter = Object.assign({}, filter);
            
            if (filter.isDropdown) {
                $(`#child-item-filter-${filter.value.id}`).children().eq(position).addClass('active');
                this.activeQuickFilter.tags = filter.dropDownList[position];
                if (typeof (filter.value.childPostion) != 'undefined' && filter.value.childPostion != null) {
                    this.activeQuickFilter.tags = filter.dropDownList[filter.value.childPostion];
                }
            }
        }
        
        localStorage.removeItem('navigateFromDetailPage');
        this.lazyLoadTrigger();
    }
    
    public checkSizeWindowMobile() {
        return screen.width <= HomeComponent.maxWidthMobile;
    }
    
    private clearCustomQuickFilter() {
        this.customQuickFilterArr.forEach((type) => {
            this[type + 'Filter'] = false;
            this.defaultFilter[type + 'Filter'] = false;
            this.defaultFilter.period = null
            this[type + 'FormControl'].setValue(null);
        })
    }
    
    arraysMatch(arr1, arr2) {
        if (arr1.length !== arr2.length) {
            return false;
        }
        
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }
        
        return true;
    }
    
    resetFilters() {
        this.limit = 10;
        this.skip = 0;
        this.selectedFilters = [];
        this.lazyLoadTriggered = true;
    }
    
    getCategories() {
        return this.categoryService.getCategories().toPromise().then(
            response => {
                if (response['Data']) {
                    return Promise.resolve(response['Data']);
                }
            },
            error => {
                console.log('GET CATEGORY ERROR ' + error);
                Promise.reject(error);
            }
        );
    }
    
    getPhotos(filterList: any[], photoOrder: PhotoOrder, limit, skip, defaultFilter, searchTerm?) {
        return this.photoService.getPhotosByOrder(filterList, photoOrder, limit, skip, this.userId, defaultFilter, searchTerm, this.selectFeed, this.partnerRoute, false, this.vipTabActive, this.followingPhotosActive).toPromise().then(
            response => {
                if (response['IsSuccess']) {
                    if (!response['Data'].length) {
                        this.lazyLoadTriggered = false;
                    }
                    
                    const result = response['Data'];
                    
                    return Promise.resolve(result);
                }
                
                return Promise.resolve([]);
            },
            error => {
                console.log('GET PHOTO API ERROR' + error);
                return Promise.reject(false);
            }
        );
    }
    
    selectFilter(category: CategoryModel, subCategory?) {
        this.previousPhotos = this.photos;
        PhotoCardComponent.photosLoaded = 0;
        if (Object.keys(this.activeQuickFilter).length !== 0) {
            //switch from quick filter mode - reset browse
            this.activeQuickFilter = {};
            this.photoOrder.selectedBrowse = {name: 'Most Recent', value: 'create_at'};
            this.photoOrder.selectedTimeFrame = {name: 'All time', value: 'allTime'};
        }
        
        localStorage.removeItem(this.photoService.convertPartnerString('activeFilter'));
        
        this.arrayFilterOption.forEach((item: any) => {
            item.class = '';
            if (item.isDropdown) {
                $(`#child-item-filter-${item.value.id} > button.active`).removeClass('active');
            }
        });
        
        this.lazyLoadTriggered = true;
        const selected_tag = {display: category.name, value: category.id};
        const isSelected: any = this.selectedFilters.find(each => {
            return each['value'] === selected_tag['value'];
        });
        
        if (!isSelected) {
            if (subCategory) {
                const filterWithSub = {
                    display: category.name,
                    value: category.id,
                    subCategories: [subCategory.id]
                }
                
                this.selectedFilters.push(filterWithSub);
            } else {
                this.selectedFilters.push({display: category.name, value: category.id});
            }
            
            this.photoService.publish(PhotoService.SET_PHOTOS_FILTER);
        } else {
            if (subCategory) {
                if (!isSelected.subCategories) {
                    isSelected.subCategories = [];
                }
                const index = isSelected.subCategories.indexOf(subCategory.id);
                if (index < 0) {
                    isSelected.subCategories.push(subCategory.id);
                } else {
                    isSelected.subCategories.splice(index, 1);
                }
            } else {
                this.selectedFilters = _.filter(this.selectedFilters, (item: any) => {
                    return item.value != category.id;
                });
            }
            
            this.removeFilter();
        }
        
        //localStorage.setItem(this.photoService.convertPartnerString('selectedFilter'), JSON.stringify(this.selectedFilters));
    }
    
    search() {
        this.activeQuickFilter = {};
        localStorage.removeItem(this.photoService.convertPartnerString('activeFilter'));
        this.arrayFilterOption.forEach((item: any) => {
            item.class = '';
            if (item.isDropdown) {
                $(`#child-item-filter-${item.value.id} > button.active`).removeClass('active');
            }
        });
        this.lazyLoadTrigger();
    }
    
    selectType(type) {
        if (type == this.selectFeed) {
            type = null;
        }
        
        // type == 99 is hardcode type for only admin
        if (type == 99) { // filter photo last 30 days when type = 99
            this.photoOrder.selectedTimeFrame = {name: 'Last 30 days', value: 'last30Days'};
        }
        
        this.selectFeed = type;
        this.resetFilters();
        //localStorage.removeItem(this.photoService.convertPartnerString('selectedFilter'));
        this.lazyLoadTrigger(type != 99);
    }
    
    selectBrowse(order: { name: string, value: string }) {
        this.photoOrder.selectedBrowse = order;
        
        if (order.value == 'create_at') {
            this.photoOrder.selectedTimeFrame = {name: 'All time', value: 'allTime'};
        } else {
            this.photoOrder.selectedTimeFrame = {name: 'Last 7 days', value: 'last7Days'};
        }
        
        this.lazyLoadTrigger(false);
    }
    
    selectRating(rating: { name: string, value: string }) {
        localStorage.setItem('selectedRating', JSON.stringify(rating));
        this.photoOrder.selectedRating = rating;
        this.lazyLoadTrigger();
    }
    
    selectTime(type: { name: string, value: string }) {
        this.photoOrder.selectedTimeFrame = type;
        this.lazyLoadTrigger(false);
    }
    
    selectOrder(order: { name: string, value: string }) {
        localStorage.setItem('selectedOrder', JSON.stringify(order));
        this.photoOrder.selectedOrder = order;
        this.lazyLoadTrigger();
    }
    
    removeFilter() {
        this.location.replaceState('/');
        this.lazyLoadTrigger();
    }
    
    isSelected(filter, subCategory?) {
        for (const each of this.selectedFilters) {
            if (subCategory) {
                if (each['value'] === filter['id'] && (each['subCategories'] && each['subCategories'].includes(subCategory.id))) {
                    return true;
                }
            } else {
                if (each['value'] === filter['id']) {
                    return true;
                }
            }
        }
        
        return false;
    }
    
    trackByFn(index, item) {
        return item.id;
    }
    
    ngAfterViewInit() {
        this._srolling = fromEvent(document, 'scroll').pipe(debounceTime(300))
            .subscribe(
                events => {
                    if (!this.active) {
                        return;
                    }
                    
                    const bottom = $(document).height();
                    const scrollPosition = Math.ceil($(window).scrollTop() + $(window).height());
                    
                    if (this.lazyLoadTriggered) {
                        if (scrollPosition + 100 >= bottom || (this.checkSizeWindowMobile() && scrollPosition + 420 >= bottom)) {
                            this.skip += 10;
                            this.lazyLoadTriggered = false;
                            if (this.activeQuickFilter.value) {
                                this.renderPhoto(this.defaultFilter.categories, this.defaultFilter, true);
                            } else {
                                return this.photoService.publish(PhotoService.LAZY_LOADING_PHOTOS, this.skip);
                            }
                        }
                        
                        return '';
                    }
                    
                    return '';
                }
            );
    }
    
    ngOnDestroy() {
        console.log('Destroy');
        this.skip = 0;
        this._srolling.unsubscribe();
        this.photoService.unsubscribe(PhotoService.SET_PHOTOS_FILTER);
        this.photoService.unsubscribe(PhotoService.LAZY_LOADING_PHOTOS);
        this.routeSubscription.unsubscribe();
    }
    
    resetPhotosList(searchKey: string) {
        const searchElement = document.getElementById('search_field');
        const isFocus = document.activeElement === searchElement;
        
        if (!searchKey && !isFocus) {
            this.resetFilters();
            return this.photoService.publish(PhotoService.SET_PHOTOS_FILTER);
        }
        
        return '';
    }
    
    onNotify(lazyLoadReady: boolean) {
        this.lazyLoadTriggered = lazyLoadReady;
    }
    
    lazyLoadTrigger(setDefault = true) {
        this.lazyLoadTriggered = true;
        PhotoCardComponent.photosLoaded = 0;
        
        if (this.activeQuickFilter.value) {
            if (this.activeQuickFilter.value.categoriesList.length > 0) {
                this.defaultFilter.categories = [];
                this.defaultFilter.categories = this.activeQuickFilter.value.categoriesWithSub;
            }
            
            if (this.customQuickFilterArr.includes(this.activeQuickFilter.value.id)) {
                // for custom quick filter
                this.defaultFilter.period = this.activeQuickFilter.value.period
                this.defaultFilter.tags = [];
                
                this.customQuickFilterArr.forEach(type => {
                    this.defaultFilter[type + 'Filter'] = (this.activeQuickFilter.value.id === type);
                })
                
            } else { // for case switch to normal quick filter
                this.clearCustomQuickFilter();
                this.defaultFilter.tags = this.activeQuickFilter.value.tags;
            }
            
            if (this.activeQuickFilter.isDropdown) {
                this.defaultFilter.tags = this.activeQuickFilter.tags;
            }
            this.renderPhoto(this.defaultFilter.categories, this.defaultFilter);
        } else {
            if (setDefault) {
                // for default sort/order value
                this.photoOrder.selectedBrowse = {name: 'Most Recent', value: 'create_at'};
                this.photoOrder.selectedOrder = {name: 'Descending', value: 'DESC'}; // for default order
                this.photoOrder.selectedTimeFrame = {name: 'All time', value: 'allTime'};
            }
            
            this.photoService.publish(PhotoService.SET_PHOTOS_FILTER);
        }
    }
    
    public updateMansoryLayout() {
        PhotoCardComponent.numberOfNewPhotoLoaded = 0;
        setTimeout(() => {
            this.photoZone._msnry.reloadItems();
            this.photoZone._msnry.layout();
        }, 300);
    }
    
    public renderPhoto(categoryFilter, defaultFilter, isPush?, searchTerm?) {
        if (!isPush) {
            this.skip = 0;
        }
        
        this.getPhotos(categoryFilter, this.photoOrder, this.limit, this.skip, defaultFilter, searchTerm).then(
            (resolve) => {
                if (!isPush) { //First time loading photo
                    this.photos =[];
                    this.pinnedPost = this.getPinnedPost();
                    if (this.pinnedPost) {
                        this.photos.push(this.pinnedPost);
                    }
                }
                
                this.photos.push(...resolve);
                
                if (resolve && resolve.length == 10) {
                    const adsPhoto = this.getAdvertisingPhotos(this.skip);
                    if (adsPhoto) {
                        this.photos.push(adsPhoto);
                    }
                }
                
                this.updateMansoryLayout();
                setTimeout(() => {
                    this.photoZone._msnry.options.transitionDuration = '1s';
                }, 600);
                
            },
            reject => console.log(reject)
        );
    }
    
    clearSearchBox() {
        this.searchTerm = '';
        this.lazyLoadTrigger();
    }
    
    static GOLDEN_FILTER_ID = 'goldenPhoto';
    static GOLDEN_LOCATION_FILTER_ID = 'goldenLocation';
    customQuickFilterArr: string[] = [
        HomeComponent.GOLDEN_LOCATION_FILTER_ID,
        HomeComponent.GOLDEN_FILTER_ID,
        HomeComponent.EDITOR_CHOICE_FILTER_ID,
    ]
    
    
    filterPhotosByMode(mode = HomeComponent.GOLDEN_FILTER_ID) {
        this[mode + 'Filter'] = !this[mode + 'Filter'];
        if (this[mode + 'Filter']) {
            const filter = {
                value: {
                    text: mode,
                    isDropdown: false,
                    dropDownList: [],
                    categoriesList: [],
                    id: mode
                }
            }
            
            const modeNeedReset =  _.filter(this.customQuickFilterArr, (type) =>{ return type !== mode; });
            modeNeedReset.forEach((type) => {
                this[type + 'Filter'] = false;
                this[type + 'FormControl'].setValue(null);
            })
            this.activeFilter(filter, null);
        } else {
            this[mode + 'FormControl'].setValue(null);
            this[mode + 'Filter'] = false;
            this.activeQuickFilter = {};
            localStorage.removeItem(this.photoService.convertPartnerString('activeFilter'));
            this.lazyLoadTrigger();
        }
    }
    
    triggerMonthPhotoFilter(period, isActive, mode = HomeComponent.GOLDEN_FILTER_ID) {
        const filter = {
            value: {
                text: mode,
                isDropdown: false,
                period: period,
                active: isActive,
                dropDownList: [],
                categoriesList: [],
                id: mode
            }
        }
        
        this.activeFilter(filter, null);
    }
    
    openDatePicker(dp) {
        dp.open();
    }
    
    filterPhotoByMonth(normalizedMonth, datepicker, date, mode = HomeComponent.GOLDEN_FILTER_ID) {
        let ctrlValue = normalizedMonth || this[mode + 'FormControl'].value || moment();
        if (!ctrlValue.month) {
            ctrlValue = moment(this[mode + 'FormControl'].value);
        }
        ctrlValue.month(normalizedMonth.month());
        
        this.customQuickFilterArr.forEach((type) => {
            this[type + 'Filter'] = (type === mode);
            this[type + 'FormControl'].setValue(type === mode ? ctrlValue.format('YYYY-MM-DD') : null);
        })
        
        const period = [
            ctrlValue.clone().startOf('month').format('YYYY-MM-DD'),
            ctrlValue.clone().endOf('month').format('YYYY-MM-DD'),
        ];
        
        this.activeQuickFilter = {};
        
        localStorage.removeItem(this.photoService.convertPartnerString('activeFilter'));
        this.triggerMonthPhotoFilter(period, true, mode);
        datepicker.close();
    }
    
    clearMonthFilter($event, datepicker, mode = 'goldenPhoto') {
        this[mode + 'FormControl'].setValue(null);
        this[mode + 'Filter'] = false;
        this.activeQuickFilter = {};
        localStorage.removeItem(this.photoService.convertPartnerString('activeFilter'));
        this.lazyLoadTrigger();
        datepicker.close();
        $(`#${mode}`).click();
    }
    
    getPinnedPost() {
        let pinnedPost = null;
        
        if (this.pinnedPostArr.length) {
            for (let post of this.pinnedPostArr) {
                if ((!post.tags || !post.tags.length || this.canShowAds(post.tags))
                    && post.partnerId == this.photoOrder.selectedPartner.id && post.language === this.userPreferredLanguage) {
                    pinnedPost = {
                        original: post.bannerUrl,
                        adsType: post.type,
                        subType : post.subType,
                        thumbnail: post.bannerThumbUrl,
                        tags: post.tags,
                        navigateUrl: post.navigateUrl,
                        partnerId: post.partnerId,
                        id: post.id + new Date().getTime(),
                        rawId: post.id,
                        type: 'advertisings',
                        height: 300,
                        width: 300
                    }
                }
            }
        }
        
        return pinnedPost;
    }
    
    getAdvertisingPhotos(skip) {
        if (this.groupId) return false;
        const showAdsAfter = 10;
        const photoNumber = skip + 10;
        if (photoNumber % showAdsAfter == 0) {
            const page = photoNumber / showAdsAfter;
            if (!this.currentAds) { // cache filter ad photos
                this.currentAds = this.advertisementPhoto.filter((el) => {
                    return (el.partnerId == this.photoOrder.selectedPartner.id) &&
                        (!el.tags || !el.tags.length || this.canShowAds(el.tags)) && this.userPreferredLanguage === el.language;
                });
            }
            
            let adsArr = this.currentAds ? this.currentAds : [];
            const length = adsArr.length;
            
            if (this.randomOrderAdvertising === null) {
                this.randomOrderAdvertising = this.getRandomInt(length);
            }
            
            if (length) {
                return adsArr[((page - 1 + this.randomOrderAdvertising) % length)]
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
    
    canShowAds(tags) {
        // filter ads by member tags
        let show = false;
        if (tags.length) {
            for (let i = 0; i < tags.length; i++) {
                show = this.membershipTags.includes(tags[i].toLowerCase());
                if (show) break;
            }
        }
        
        return show;
    }
    
    navigateToRankingList() {
        this.router.navigateByUrl('/user/golden-ranking');
    }
}
